// extracted by mini-css-extract-plugin
export default {"sectionHeading":"MenuItems_sectionHeading__CHGXf","menuItems":"MenuItems_menuItems__RrU3z"};